import { getChipListErrors, isValidSortOrderInput } from '../fields/displayMetadata';
import { getLifecycleErrors } from '../fields/lifecycleMetadata';

export const cloneConfig = (config) => JSON.parse(JSON.stringify(config));

export const numberFromInput = (value, fallback = 0) => {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : fallback;
};

export const linesFromText = (value) => String(value || '')
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);

export const validateOfferEditor = (values = {}, options = {}) => {
    const errors = [];

    if (!String(values.displayName || '').trim()) {
        errors.push('Display name is required.');
    }
    if (!isValidSortOrderInput(values.sortOrder)) {
        errors.push('Sort order must be numeric.');
    }

    (options.priceFields || []).forEach((field) => {
        const value = values[field];
        if (
            value !== ''
            && value !== null
            && value !== undefined
            && (!Number.isFinite(Number(value)) || Number(value) < 0)
        ) {
            errors.push(`${field} must be a non-negative number.`);
        }
    });

    errors.push(...getLifecycleErrors(values));

    if (values.customerEmailEligible && linesFromText(values.emailBulletsText).length === 0) {
        errors.push('Customer-facing email bullets are required when customer email eligible is on.');
    }

    if (options.validateChips !== false) {
        errors.push(
            ...getChipListErrors(values.topBadges, 'Top badge'),
            ...getChipListErrors(values.displayChips, 'Detail chip')
        );
    }

    return errors;
};
